/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Details from './Details/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/Inputs/Content/Message/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let messageValueData = fromData.useDataValue({ viewPath,
context: 'message',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 overflowX="hidden"
 overflowY="hidden"
 textOverflow="ellipsis"
 height={20}
 width={200}
 data="message"
 text={messageValueData}
 flexShrink={1}
 flexGrow={1}
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Details/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Details/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="View details"
/>
)}
</TysiaButton>
</div>
<Details
  viewPath={`${viewPath}/Details`}
/>
{children}
</React.Fragment>)
}